import { render, staticRenderFns } from "./SettingPlanDetailPad.vue?vue&type=template&id=38da705e&scoped=true&"
import script from "./SettingPlanDetailPad.vue?vue&type=script&lang=js&"
export * from "./SettingPlanDetailPad.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanDetailPad.vue?vue&type=style&index=0&id=38da705e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da705e",
  null
  
)

export default component.exports